// extracted by mini-css-extract-plugin
export default {"clearQueue":"EmailQueueActions_clearQueue__lnmzt","confirmDescription":"EmailQueueActions_confirmDescription__WUkyX"};